import script from "./ColumnFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColumnFilter.vue?vue&type=script&setup=true&lang=ts"

import "./ColumnFilter.vue?vue&type=style&index=0&id=81cdbb14&lang=scss&scoped=true"

import exportComponent from "/builds/kligmanbb/medsafe-smart-pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81cdbb14"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
